window.toggleMenu = function () {
  $('body').toggleClass('sidebar-open')
  toggleHamburger()
  return false
}

window.toggleHamburger = function () {
  $('.js-header__hamburger').toggleClass('open')
  var text = $('.js-header__hamburger.open').length ? 'Close menu' : 'Menu'
  $('.js-header-subnav__menu-text').text(text)
}
